import toast from "../ui/toast";

const module = {
	sendingCount: 0,
	/**
	 * Returns a Promise.
	 */
	send(url, method, payloadObject, options) {
		var doNotNotify, doNotCatch;
		if (options) {
			({doNotNotify, doNotCatch} = options);
		}
		if (!doNotNotify) {
			module.sendingCount += 1;
		}
		var afterSending = function() {
			if (!doNotNotify) {
				module.sendingCount -= 1;
			}
		};
		var promise;
		if (method === 'GET' || method === undefined) {
			promise = $.getJSON(url);
		} else {
			promise = $.ajax(url, {
				data: payloadObject && JSON.stringify(payloadObject) || null,
				method: method
			});
		}
		promise.then(afterSending, function (error) {
			afterSending();
			console.error(error);
			if (!doNotCatch) {
				toast.error(error.statusText + "<br/>" + error.responseText);
			}
		});
		return promise;
	}
};

export default module;



// WEBPACK FOOTER //
// ./src/core/ajax.js